import { ShortFormatter } from '../../../../lib/formatting/shortFormatter';
import { DiscoveryTokenResult } from '../../../../utils/discovery/types';

const shortFormatter = new ShortFormatter();

export function HoldersCell({ item }: { item: DiscoveryTokenResult }) {
  if (!item || !item.token) {
    return null;
  }

  return <div className="flex items-center shrink-0">{shortFormatter.format(item.numHolders)}</div>;
}
